






















































































import Vue from 'vue'
import { getUserInfo } from '@/utils/auth'
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
const slsp = new SupplierServiceProxy()

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item:{
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      rolesList: [],
      value: undefined,
      deptIds: [],
      loading:false
    }
  },
  methods: {
    onClose() {
      this.form.resetFields()
      this.$emit('close', false)
    },
    save() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          Object.keys(values).forEach(key => {
            const str = values[key]
            if(str !== undefined || str !== null){
              values[key] = str.replace(/\s+/g,"")
            }
          });
          this.loading = true
          slsp.updateSupplier(values,this.item.id).then(res => {
            this.form.resetFields()
            this.$message.success(this.$t('page_mdc_setting_edit_success'))
            this.$emit('reload')
            this.loading = false
          }).catch(() =>{
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    }
  }
})
